"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var StepConnectorTheme = function StepConnectorTheme(colors) {
  return {
    styleOverrides: {
      root: {
        flex: '1 1 auto',
        color: colors.lynch,
        marginTop: 0,
        '&.Mui-active [class^=MuiStepConnector-line]': {
          backgroundColor: colors.bleuDigital100
        },
        '&.Mui-completed [class^=MuiStepConnector-line]': {
          backgroundColor: colors.bleuDigital100
        }
      },
      alternativeLabel: {
        position: 'absolute',
        top: '50px',
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)',
        margin: '-13px'
      },
      line: {
        height: 5,
        border: 'none',
        backgroundColor: colors.lynch,
        borderRadius: 1
      },
      lineHorizontal: {
        borderTopWidth: 0,
        margin: '1px 0 0 -1px'
      },
      vertical: {
        width: '5px',
        marginLeft: '6px',
        marginTop: '-22px',
        marginBottom: '-9px',
        padding: 0
      },
      lineVertical: {
        minHeight: '50px',
        borderLeftWidth: 0,
        margin: '0 0'
      }
    }
  };
};

var _default = StepConnectorTheme;
exports["default"] = _default;